module.exports = __webpack_public_path__ + "static/media/renault-group-logo.5596783d.png";